/* eslint-disable react/display-name */
import React, {useEffect, useState} from "react"
import {SelectChangeEvent, useTheme, MenuItem, MenuProps} from "@mui/material"
import {Sorting} from "../../../../../models/Sorting"
import {StandardStyledSelectSort} from "./components"
import {getSXMenuProps} from "../../../components"

export interface StandardSelectSortProps {
    value: string | undefined
    onChange: ((event: SelectChangeEvent<unknown>, child: React.ReactNode) => void) &
        React.FormEventHandler<HTMLDivElement>
    open: boolean
    onOpen: () => void
    onClose: () => void
    ref: React.RefObject<HTMLDivElement>
    toggleDropdown: () => void
    sortOptions: Sorting
}

export const StandardSelectSort = ({
    value,
    onChange,
    open,
    ref,
    toggleDropdown,
    sortOptions,
}: StandardSelectSortProps) => {
    const theme = useTheme()
    const [sxMenuProps, setSxMenuProps] = useState(getSXMenuProps(false, theme))

    useEffect(() => {
        setSxMenuProps(getSXMenuProps(false, theme))
    }, [open])

    return (
        <StandardStyledSelectSort
            value={value}
            onChange={onChange}
            open={open}
            onOpen={toggleDropdown}
            onClose={toggleDropdown}
            MenuProps={sxMenuProps as unknown as MenuProps}
            ref={ref}
            labelId="desktop-sort-select-label"
            id="desktop-sort-select"
            data-testid="plp-desktop-sort-button"
        >
            {sortOptions?.options.map(opt => (
                <MenuItem
                    value={opt.value}
                    key={opt.value}
                    onMouseOver={() => setSxMenuProps(getSXMenuProps(sortOptions.selected !== opt.value, theme))}
                >
                    <span>{opt.name}</span>
                </MenuItem>
            ))}
        </StandardStyledSelectSort>
    )
}
export default StandardSelectSort
